import { resolveMac88LocalImageUrl } from './mac88LocalImage'

const preloadedUrls = new Set<string>()

export function preloadCasinoGameImages(urls: string[], limit = 15): void {
  urls.slice(0, limit).forEach((url) => {
    if (!url || preloadedUrls.has(url)) return
    preloadedUrls.add(url)
    const img = new Image()
    img.decoding = 'async'
    img.src = url
  })
}

export function resolveCasinoGameImageUrl(game: Record<string, unknown>): string {
  const localMac88 = resolveMac88LocalImageUrl(game)
  if (localMac88) return localMac88
  const url = game.game_images || game.image_url || game.game_image
  return typeof url === 'string' ? url : ''
}
